import moment from 'moment-timezone';
import store from '../redux/store';
import 'moment/locale/es';
import 'moment/locale/tr';
import { getUserLanguage } from '../service/authService';

export const getUserTimeZoneDateTime = (date) => {
  if (date) {
    moment.locale(getUserLanguage());
    const userTimeZone =
      store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
        ?.timezone;

    return moment.tz(date, userTimeZone).format('DD/MM/YYYY hh:mm A');
  }
  return '-';
};

export const getUserTimeZoneDateLong = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  return moment.tz(date, userTimeZone).format('dddd, MMMM DD, YYYY');
};

export const getChatHeaderDate = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;
  if (moment(date).calendar().includes('Today')) {
    return 'Today';
  }
  return moment.tz(date, userTimeZone).format('dddd, MMMM DD, YYYY');
};

export const getChatMessageDate = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  return moment.tz(date, userTimeZone).format('ddd, hh:mmA');
};
export const getUserTimeZoneTime = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  return moment.tz(date, userTimeZone).format('hh:mm A');
};
export const getUserTimeZoneTiDate = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  return moment.tz(date, userTimeZone).format('MMMM DD, YYYY');
};

export const getUserTimeZoneDateWithOrdinalIndicators = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  return moment.tz(date, userTimeZone).format('Do MMM YYYY');
};

export const getUserTimeZoneDateFormat = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  const dateFormat = moment.tz(date, userTimeZone).format('DD/MM/YYYY');
  if (dateFormat === 'Invalid date' || dateFormat === 'Fecha inválida') {
    return '--';
  }
  return moment.tz(date, userTimeZone).format('DD/MM/YYYY') || '--';
};

export const getUserTimeZoneTimeFormat = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  const timeFormat = moment.tz(date, userTimeZone).format('HH:mm:ss');
  if (timeFormat === 'Invalid date') {
    return '--';
  }
  return moment.tz(date, userTimeZone).format('HH:mm:ss') || '--';
};
export const getUserTimeZoneTimeFormatOnlyhhmm = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  const timeFormat = moment.tz(date, userTimeZone).format('HH:mm');
  if (timeFormat === 'Invalid date') {
    return '--';
  }
  return moment.tz(date, userTimeZone).format('HH:mm') || '--';
};

export const compareDatesEqualWithoutTime = (date1, date2, allowEqual) => {
  moment.locale(getUserLanguage());
  const date1WithoutTime = new Date(date1);
  date1WithoutTime?.setHours(0, 0, 0, 0);

  const date2WithoutTime = new Date(date2);
  date2WithoutTime?.setHours(0, 0, 0, 0);

  return allowEqual
    ? date1WithoutTime.getTime() >= date2WithoutTime.getTime()
    : date1WithoutTime.getTime() > date2WithoutTime.getTime();
};

export const changeDateToDoFormat = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;

  return moment.tz(date, userTimeZone).format('DD MMM YYYY HH:mm A');
};

export function compareDatesWithTime(date1, date2) {
  const fromTime = new Date(date1).getTime();
  const toTime = new Date(date2).getTime();
  if (fromTime <= toTime) {
    return false;
  }
  return true;
}

export function compareDatesWithEqualTime(date1, date2) {
  const fromTime = new Date(date1).getTime();
  const toTime = new Date(date2).getTime();
  if (fromTime < toTime) {
    return false;
  }
  return true;
}
export const getUserTimeZoneDateTimeTest = (date) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;
  const commentDate = moment.tz(date, userTimeZone);
  const now = moment.tz(userTimeZone);
  if (now.diff(commentDate, 'hours') < 24) {
    return commentDate.fromNow();
  }

  return commentDate.format('DD/MM/YYYY hh:mm A');
};

export const getUserTimeZoneDateTimeLanguageBased = (date) => {
  moment.locale(getUserLanguage());
  const commentDate = moment(date);
  const now = moment();

  const dateFormats = {
    en: 'DD/MM/YYYY hh:mm A',
    tr: 'DD.MM.YYYY HH:mm',
    es: 'DD/MM/YYYY HH:mm',
  };

  const selectedFormat = dateFormats[getUserLanguage];

  if (now.diff(commentDate, 'hours') < 24) {
    return commentDate.fromNow();
  }

  return commentDate.format(selectedFormat);
};

export const dateRegex =
  /^Date(.+?)(?:\d+)-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})Z$/;

export const fetchUtcDate = (date, isIso = false) => {
  moment.locale(getUserLanguage());
  const userTimeZone =
    store.getState().omniProfile.profileDetail?.fetchProfileDetails?.data
      ?.timezone;
  const newDate = moment.tz(date, userTimeZone);
  const utcNewDate = new Date(newDate);
  if (utcNewDate.toDateString() === 'Invalid Date') {
    const newupdateDate = moment(date, 'DD/MM/YYYY');
    if (newupdateDate.toISOString() !== null) {
      if (isIso) return newupdateDate.toISOString();
      return new Date(newupdateDate.toISOString());
    }
    return null;
  }
  if (isIso) return utcNewDate.toISOString();
  return utcNewDate;
};
